import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { LeadCycleRequest, LeadCycleResponse, PageResponse } from '../models/lead-cycle.model';

@Injectable({
  providedIn: 'root'
})
export class LeadCycleApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) { }

  // GET /api/lead-cycles?businessId=&page=&size=
  getCycles(businessId: number, page = 0, size = 100): Observable<LeadCycleResponse[]> {
    const params = new HttpParams()
      .set('businessId', businessId.toString())
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<PageResponse<LeadCycleResponse>>(`${this.apiUrl}/lead-cycles`, { params })
      .pipe(map(res => res.content));
  }

  // GET /api/lead-cycles/{id}?businessId=
  getCycleById(id: number, businessId: number): Observable<LeadCycleResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<LeadCycleResponse>(`${this.apiUrl}/lead-cycles/${id}`, { params });
  }

  // POST /api/lead-cycles
  createCycle(cycle: LeadCycleRequest): Observable<LeadCycleResponse> {
    return this.http.post<LeadCycleResponse>(`${this.apiUrl}/lead-cycles`, cycle);
  }

  // PUT /api/lead-cycles/{id}
  updateCycle(id: number, cycle: LeadCycleRequest): Observable<LeadCycleResponse> {
    return this.http.put<LeadCycleResponse>(`${this.apiUrl}/lead-cycles/${id}`, cycle);
  }

  // DELETE /api/lead-cycles/{id}?businessId=
  deleteCycle(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/lead-cycles/${id}`, { params });
  }

  // POST /api/lead-cycles/reorder?businessId= — body: ids en el nuevo orden (lista COMPLETA).
  // El backend asigna display_order por posición empezando en 1. Responde 204 sin body.
  reorderCycles(businessId: number, orderedIds: number[]): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.post<void>(`${this.apiUrl}/lead-cycles/reorder`, orderedIds, { params });
  }
}
